import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { Link } from 'react-router-dom';
import Button from '../elements/Button';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const HealthcareView = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {


  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Metabolic and Urinary Health',
    paragraph: "Metabolic and Urinary Health Analytics through Automatic Urine Waste Analysis. High throughput, instant results, lower cost per test and zero waste."
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Healthcare
                  </div>
                <h3 className="mt-0 mb-12">
                  Performance Athletics and Disease Prevention
                  </h3>
                <p className="m-0">
                  Personal Health means Applied to You. From the Athlete looking to gain an edge, to the High Risk Population, anyone can benefit from the knowledge of their metabolic heatlh.
                  Close the Feedback between regimen and results with daily monitoring by searching for byproducts of metabolic breakdown in your bodily waste fluid.
                  </p>
                <p className="m-0">
                 Reduce the amount of physical waste generated from test kits and disposables
                 enables Continuous Health Monitoring Measurements with Zero waste.
                  </p>
              </div>
                <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/mobilesense-urinehealth.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>




            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div>
                <h3 className="mt-0 mb-12">
                  High Quality Data
                  </h3>
                <p className="m-0">
                  SERS Spectroscopy uses light to interrogate fluids,direct optical chemical detection. This technique has advantages over other sensing techniques.

                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/output-report-mobilesense.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>



            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Automation Software
                </div>
                <h3 className="mt-0 mb-12">
                  Data Visualization
                  </h3>
                <p className="m-0">
                  Featuring Our New Software Application to Automate Data Collection. Capture and Visualize Data with Automated Reports for Your Clients.
                  </p>



              </div>
                <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Community Intelligence
                  </div>
                <h3 className="mt-0 mb-12">
                  Better Decision Making
                  </h3>
                <p className="m-0">
                Review Data and Share Analysis Reports. Real Insights for Better Decision Making.  </p>
                <Link to={'/samplereport'} >
                <button className="button button-secondary button-wide-mobile button-sm" > View Sample Report </button>
                </Link>
              </div>
            </div>



    <div className="split-item">


            </div>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Knowledge Base
                </div>
                <h3 className="mt-0 mb-12">
                  Building on Decades of Research
                  </h3>
                <p className="m-0">
                  The Consituents of Urine can indicate that your body is processing nutrients suboptimally, or fighting an infection.
                  Over Time We Hope to Discover how Biomarkers found in your Urine correlate to patient health. 
                  </p>

              </div>
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Selected Science Publications
                </div>
                <h3 className="mt-0 mb-12">
                  References
                  </h3>
                    <Button tag="a" color="primary" wideMobile href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7747921/">
                    [1]</Button>
                    <p className="m-0">Rapid and label-free urine test based on surface-enhanced Raman spectroscopy for the non-invasive detection of colorectal cancer at different stages</p>
                    <Button tag="a" color="primary" wideMobile href="https://www.sciencedirect.com/science/article/abs/pii/S1386142520310878">
                    [2]</Button>
                    <p className="m-0">Detecting urine metabolites of bladder cancer by surface-enhanced Raman spectroscopy</p>
                    <Button tag="a" color="primary" wideMobile href="https://www.spiedigitallibrary.org/conference-proceedings-of-spie/6826/1/Surface-enhanced-Raman-spectroscopy-of-urine-by-an-ingenious-near/10.1117/12.756716.short">
                    [3]</Button>
                    <p className="m-0">Surface-enhanced Raman spectroscopy of urine by an ingenious near-infrared Raman spectrometer</p>



              </div>


            </div>



          </div>
        </div>
      </div>
    </section>
  );
}

HealthcareView.propTypes = propTypes;
HealthcareView.defaultProps = defaultProps;

export default HealthcareView;